import React from 'react'

export const textArea = ({input, label, type, meta: {touched, error}, disabled}) => (
	<div className={'form-group ' + (touched && error ? 'is-invalid' : '')}>
		<label htmlFor={input.name}>
			{label}
		</label>

		<textarea id={input.name}
		          {...input}
		          disabled={disabled === true}
		          className={'form-control ' + (touched && error ? 'is-invalid' : '')}
		/>

		{touched && error && <p className="text-danger"><span>{error}</span></p>}
	</div>
)
